import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import SaltFilterCriteria from './SaltFilterCriteria'
import SaltList from './SaltList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './SaltAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setSaltDashboardSaltList } from '../../store/slice/PharmaSlice';

export default function SaltListView({setShowEdit,setSaltId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.saltDashboard);   

    const [filteredSaltList, setFilteredSaltList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { saltDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (saltDashboard.saltList.length>-1){
        setFilteredSaltList(saltDashboard.saltList);
        transformToCardFormat(saltDashboard.saltList, setCardList);
      }
    },[saltDashboard.saltList])

    useEffect(()=>{
          transformToCardFormat(filteredSaltList, setCardList);
      },[filteredSaltList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredSaltList(saltDashboard.saltList);
            transformToCardFormat(saltDashboard.saltList, setCardList);

        } else {
            setFilteredSaltList(
                saltDashboard.saltList
                    .filter(salt=> salt.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(saltDashboard.filteredSaltList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <SaltList
                    setShowEdit={setShowEdit}
                    setSaltId = {setSaltId}
                    tableList={filteredSaltList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}